(function($) {
    if (!$) {
        return;
    }

    const jqueryTrigger = $.event.trigger;
    // trigger signature: function (event, data, elem, onlyHandlers)
    $.event.trigger = function(event, data, elem, onlyHandlers) {
        try {
            // Dispatch regular event, prefixed with 'jquery:'
            const eventPrefix = 'jquery:';
            const prefixedEventName = eventPrefix + event;
            const jsEvent = data
                ? new CustomEvent(prefixedEventName, { detail: data })
                : new CustomEvent(prefixedEventName);
            const elem2dispatchEvent = elem ? elem : window;
            elem2dispatchEvent.dispatchEvent(jsEvent);
        } catch (error) {
            return;
        }

        // Dispatch jquery event
        jqueryTrigger(event, data, elem, onlyHandlers);
    };
})(window.jQuery);
